import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalCarItem" })
export default class GlobalCarItem extends Vue {
    public localizer: any = Localizer;
    public isDetail: boolean = false;
    public isCompactProductList: string[] = [];
    public section: string = "TechnicalData";

    public isProductApplicationBrandsLoader: boolean = false;
    public isProductApplicationsLoader: boolean = false;

    public productFavoritesList: any[] = [];

    public productImages: any = null;
    public isTechnicalDrawingImage: boolean = false;
    public productApplicationBrands: any[] = null;
    public selectedProductApplicationBrand: any = null;
    public productApplications: any[] = [];
    public pageCount: number = 0;
    public pageIndex: number = 0;
    public bremboCode: string = null;
    public brandCode: string = null;
    public referencesOE: any[] = [];

    public slotData: {} = null;

    @Prop() readonly productType: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.setSlotData();
    }

    public setSlotData() {
        const self = this;
        this.slotData = {
            isDetail: function () {
                return self.isDetail;
            },
            isCompactProductList: function () {
                return self.isCompactProductList;
            },
            setIsDetail: function (bremboCodes: string) {
                self.setIsDetail(bremboCodes);
            },
            setIsCompactProductList: function (bremboCode: string) {
                self.setIsCompactProductList(bremboCode);
            },
            section: function () {
                return self.section;
            },
            showTechnicalData: function (bremboCode: string, bremboCodes: string) {
                self.showTechnicalData(bremboCode, bremboCodes);
            },
            showProductApplications: function (bremboCode: string) {
                self.showProductApplications(bremboCode);
            },
            showProductManufacturerReferences: function (bremboCode: string) {
                self.showProductManufacturerReferences(bremboCode);
            },
            productImages: function () {
                return self.productImages;
            },
            isTechnicalDrawingImage: function () {
                return self.isTechnicalDrawingImage;
            },
            checkProductImage: function (bremboCode: string) {
                return self.checkProductImage(bremboCode);
            },
            getProductImage: function (bremboCode: string, type: string) {
                return self.getProductImage(bremboCode, type);
            },
            getProductImageZoom: function (bremboCode: string, type: string) {
                return self.getProductImageZoom(bremboCode, type);
            },
            toggleAddProductToFavourites: function (bremboCode: string) {
                self.toggleAddProductToFavourites(bremboCode);
            },
            productFavoritesList: function () {
                return self.productFavoritesList;
            },
            isProductApplicationBrandsLoader: function () {
                return self.isProductApplicationBrandsLoader;
            },
            productApplicationBrands: function () {
                return self.productApplicationBrands;
            },
            selectedProductApplicationBrand: function () {
                return self.selectedProductApplicationBrand;
            },
            setSelectedProductApplicationBrand: function (productApplicationBrand: any, bremboCode: string) {
                self.setSelectedProductApplicationBrand(productApplicationBrand, bremboCode);
            },
            isProductApplicationsLoader: function () {
                return self.isProductApplicationsLoader;
            },
            productApplications: function () {
                return self.productApplications;
            },
            pageCount: function () {
                return self.pageCount;
            },
            pageIndex: function () {
                return self.pageIndex;
            },
            setPage: function (page: number) {
                self.setPage(page);
            },
            searchApplication: function (brandCode: string, modelCode: string, typeCode: string, modelYear: string = null) {
                self.searchApplication(brandCode, modelCode, typeCode, modelYear);
            },
            getProductApplicationYear: function (dateStart: string, dateEnd: string) {
                return self.getProductApplicationYear(dateStart, dateEnd);
            },
            referencesOE: function () {
                return self.referencesOE;
            },
            searchCompetitor: function (bremboCode: string) {
                self.searchCompetitor(bremboCode);
            }
        }
    }

    public async setIsDetail(bremboCodes: string) {
        this.isDetail = !this.isDetail;

        if (this.isDetail) {
            if (this.section === "TechnicalData") {
                if (!this.productImages || this.productImages.length === 0) {
                    await this.getProductImages(bremboCodes);

                    const images = this.productImages.filter(x => x.type === "Drawing_1" || x.type === "Drawing_2");
                    if (images.length !== 0) {
                        this.isTechnicalDrawingImage = true;
                    }
                }

                this.getFavoritesList();
            }

            GTagHelper.sendEvent("click", "productlist", "expand");
            GTagHelper.sendPageView({ "page_path": "/virtual/product-expand", "page_title": "Product expand" });
        } else {
            this.isCompactProductList = [];
        }
    }

    public setIsCompactProductList(bremboCode: string) {
        let index = this.isCompactProductList.indexOf(bremboCode);
        if (index > -1) {
            this.isCompactProductList.splice(index, 1);
        } else {
            this.isCompactProductList.push(bremboCode);
        }
    }

    public async showTechnicalData(bremboCode: string, bremboCodes: string) {
        this.section = "TechnicalData";

        GTagHelper.sendEvent("click", "productlist_tab", "technical_data");

        if (!this.productImages || this.productImages.length === 0) {
            await this.getProductImages(bremboCodes);
        }
    }

    public showProductApplications(bremboCode: string) {
        this.section = "ProductApplications";

        GTagHelper.sendEvent("click", "productlist_tab", "applications");

        if (!this.productApplicationBrands || this.productApplicationBrands.length === 0) {
            this.getProductApplicationBrands(bremboCode);
        }
    }

    public showProductManufacturerReferences(bremboCode: string) {
        this.section = "ProductManufacturerReferences";

        GTagHelper.sendEvent("click", "productlist_tab", "manufacturer_references");

        if (!this.referencesOE || this.referencesOE.length === 0) {
            this.getProductOE(bremboCode);
        }
    }

    public async getProductImages(bremboCodes: string) {
        this.productImages = (await this.$store.dispatch("catalogueListStore/getProductImages", { bremboCodes: bremboCodes })).data;
    }

    public checkProductImage(bremboCode: string): boolean {
        return this.productImages?.some(item => item.bremboCode === bremboCode && (item.type === "Product_1" || item.type === "Product_2" || item.type === "Product_3"));
    }

    public getProductImage(bremboCode: string, type: string): string {
        const image = this.productImages?.find(item => item.bremboCode === bremboCode && item.type === type);
        return image && image.imageUrl ? image.imageUrl : "";
    }

    public getProductImageZoom(bremboCode: string, type: string): string {
        const image = this.productImages?.find(item => item.bremboCode === bremboCode && item.type === type);
        return image && image.imageZoomUrl ? image.imageZoomUrl : "";
    }

    public async toggleAddProductToFavourites(bremboCode: string) {
        var params = {
            favoriteType: "Product",
            referenceType: this.productType,
            referenceCode: bremboCode
        };

        const response = (await Axios.post(this.routes.ProfileFavorite_IsFavorite, { referenceCode: bremboCode })).data;

        if (response.success) {
            await this.removeFromFavourites(bremboCode);
        } else {
            await this.addToFavourites(params);
            GTagHelper.sendCustomEvent("click", "Car");
            GTagHelper.sendCustomEvent("click", { favourite_car_product: this.productType });
            GTagHelper.sendCustomEvent("click", { favourite_code_product: bremboCode });
        }
    }

    public async removeFromFavourites(referenceCode: string) {
        const response = (await Axios.post(this.routes.ProfileFavorite_FavoriteRemove, { referenceCode: referenceCode })).data;

        if (response) {
            await this.getFavoritesList();
        }
    }

    public async addToFavourites(params: any) {
        const response = (await Axios.post(this.routes.ProfileFavorite_FavoriteAdd, params)).data;

        if (response) {
            await this.getFavoritesList();
        }
    }

    public async getFavoritesList() {
        const response = (await Axios.post(this.routes.ProfileFavorite_GetFavoriteList, null)).data;

        if (response.favorites) {
            this.productFavoritesList = response.favorites;
        }
    }

    public async getProductApplicationBrands(bremboCode: string) {
        this.isProductApplicationBrandsLoader = true;

        let response = await this.$store.dispatch("catalogueListStore/getProductApplicationBrands", {
            bremboCode: bremboCode
        });
        if (response && response.data) {
            this.productApplicationBrands = response.data;

            if (!this.selectedProductApplicationBrand) {
                this.selectedProductApplicationBrand = this.productApplicationBrands[0];
                this.isProductApplicationBrandsLoader = false;
                this.getProductApplications(bremboCode, this.selectedProductApplicationBrand.brandCode, 1);
            }
        } else {
            this.productApplicationBrands = [];
            this.selectedProductApplicationBrand = null;
            this.isProductApplicationBrandsLoader = false;
        }
    }

    public async getProductApplications(bremboCode: string, brandCode: string, page: number) {
        this.isProductApplicationsLoader = true;
        this.bremboCode = bremboCode;
        this.brandCode = brandCode;

        this.productApplications = [];
        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductApplications, { bremboCode: bremboCode, brandCode: brandCode, page: page })).data;
        this.productApplications = response.applicationItems;
        this.pageCount = response.pageCount;
        this.pageIndex = response.pageIndex;

        this.isProductApplicationsLoader = false;
    }

    public async setPage(page: number) {
        await this.getProductApplications(this.bremboCode, this.brandCode, page);
    }

    public setSelectedProductApplicationBrand(productApplicationBrand: any, bremboCode: string) {
        if (this.selectedProductApplicationBrand !== productApplicationBrand) {
            this.selectedProductApplicationBrand = productApplicationBrand;
            this.getProductApplications(bremboCode, this.selectedProductApplicationBrand.brandCode, 1);
        }
    }

    public getProductApplicationYear(dateStart: string, dateEnd: string) {
        let dateFormatted = dateStart + " - " + dateEnd;

        if (dateStart.includes("<-") || dateEnd.includes("->")) {
            dateFormatted = dateStart.replace("<-", "<span class=\"zmdi fastic-long-arrow-prev\"></span>") + " " + dateEnd.replace("->", "<span class=\"fastic-long-arrow-next\"></span>");
        }
        else if (dateStart.includes("-") || dateEnd.includes("-")) {
            dateFormatted = dateStart.replace("<-", "<span class=\"zmdi fastic-long-arrow-prev\"></span>") + " " + dateEnd.replace("->", "<span class=\"fastic-long-arrow-next\"></span>");
        }

        return dateFormatted;
    }

    public async searchApplication(brandCode: string, modelCode: string, typeCode: string, modelYear: string = null) {
        let response = await this.$store.dispatch("catalogueSearchStore/searchType", {
            brandCode: brandCode,
            modelCode: modelCode,
            typeCode: typeCode,
            modelYear: modelYear
        });

        if (response && response.data && response.data.url) {
            window.location.href = response.data.url;
        }
    }

    public async getProductOE(bremboCode: string) {
        let response = await this.$store.dispatch("catalogueListStore/getProductManufacturerReferences", { bremboCode: bremboCode });
        if (response && response.data) {
            this.referencesOE = response.data;
        } else {
            this.referencesOE = [];
        }
    }

    public async searchCompetitor(bremboCode: string) {
        let response = await this.$store.dispatch("catalogueSearchStore/searchCode", { code: bremboCode });
        if (response && response.data && response.data.url) {
            window.location.href = response.data.url;
        }
    }
}